export default __webpack_public_path__ + "static/media/gallery154_4.ab5b510f.png";